
namespace Matrix.Data {

	@Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
	export class ClientEntityDialog extends SiteEntityDialog<any, ClientEntityOptions> {
		protected getFormKey() { return this.options.module + "." + this.options.identifier; }
		protected getIdProperty() { return this.options.idProperty; }
		protected getLocalTextPrefix() { return this.options.module + "." + this.options.identifier; }
        protected getNameProperty() { return ClientTableRow.nameProperty; }
		protected getService() { return this.options.module + "/" + this.options.identifier; }

        protected form = new ClientTableForm(this.idPrefix);

		constructor(options: ClientEntityOptions) {
            super(options);
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            var cloneButton = Q.tryFirst(buttons, x => x.cssClass === "clone-button");
            if (cloneButton) {
                cloneButton.onClick = () => {
                    if (!this.isEditMode()) {
                        return;
                    }
                    var cloneEntity = this.getCloningEntity();
                    Serenity.Widget.create({
                        type: Q.getInstanceType(this),
                        options: this.options,
                        init: function (w) {
                            return Serenity.SubDialogHelper.bubbleDataChange(Serenity.SubDialogHelper.cascade(w, this.element), this, true)
                                .loadEntityAndOpenDialog(cloneEntity, null);
                        }
                    });
                }
            }

            return buttons;
        }

    }
}